export default "__VITE_ASSET__7npyrV1F__"